import { Subject } from 'rxjs/Subject';
import { DOMEvent, TargetGroup } from '../dom-generator/types';
import { UrlUtility } from '../utility/url';
import { WebClient } from './webclient.service';



export class DataService {

    static init() {
        DataService._targetGroups = [{
            "id": 19,
            "name": "Default",
            "is_default": true,
        }];
        // return new Promise((resolve, rej) =>
        //     WebClient.getTargetGroups().then(resp => {
        //         DataService._targetGroups = resp.targetGroups;
        //         resolve();
        //     }));
    }

    private static _targetGroups: Array<TargetGroup>;
    public static get targetGroups(): Array<TargetGroup> {
        return DataService._targetGroups;
    }



    private static _targetGroupId: number;
    public static get targetGroupId(): number {
        return DataService._targetGroupId;
    }

    public static get targetGroupName(): string {
        let gr = DataService._targetGroups.filter(gr => gr.id == DataService._targetGroupId);
        if (gr.length > 0)
            return gr[0].name;
        return ''
    }



    public static set targetGroupId(v: number) {
        if (DataService._targetGroupId != v) {
            DataService._targetGroupId = v;
            DataService.dataChange$.next({
                event: 'target-group-change',
                targetgroupId: v
            } as DOMEvent);
        }
    }



    private static _pageID: number = -1;
    public static get pageID(): number {
        if (DataService._pageID < 0) {
            DataService._pageID = UrlUtility.getUrlParam(location.href, 'id');
        }
        return DataService._pageID;
    }

    private static _module: string;
    public static get module(): string {
        if (!DataService._module)
            DataService._module = UrlUtility.getUrlParam(location.href, 'module');
        return DataService._module;
    }

    public static dataChange$: Subject<DOMEvent> = new Subject<DOMEvent>();

    public static setVersionData() {
        let param = UrlUtility.getUrlParam(location.href, 'module');
        if (param && param.length) {
            param = param.replace('\\', '');
            if (param == 'AppCustomPage' || param == 'AppGuidePage' || param == 'AppProductCategory') {
                DataService.versioned = true;
            }
        }
    }

    private static _versioned: boolean;
    public static get versioned(): boolean {
        return DataService._versioned;
    }
    public static set versioned(v: boolean) {
        DataService._versioned = v;
    }



}
